var _style, _circle, _rect, _g, _path, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg03Charging(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    width: 240,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n#glow{transform-origin:120px 125px;animation:pulse 1.4s ease-in-out infinite}\n@keyframes pulse{0%,100%{opacity:.25;transform:scale(1)}50%{opacity:.6;transform:scale(1.09)}}\n#bolt{transform-origin:120px 125px;animation:zap 1.4s ease-in-out infinite}\n@keyframes zap{0%,100%{opacity:.55;transform:scale(.92)}50%{opacity:1;transform:scale(1.08)}}\n#eyes{animation:look 2.8s ease-in-out infinite}\n@keyframes look{0%,100%{transform:translateY(0)}50%{transform:translateY(-5px)}}\n.spark{animation:rise 1.8s linear infinite}\n.s2{animation-delay:.6s}.s3{animation-delay:1.2s}\n@keyframes rise{0%{opacity:0;transform:translateY(0)}30%{opacity:1}100%{opacity:0;transform:translateY(-38px)}}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "glow",
    cx: 120,
    cy: 125,
    r: 92,
    fill: "#6FE3D0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 50,
    width: 160,
    height: 150,
    rx: 52,
    fill: "#6FE3D0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eyes",
    fill: "#0E2A2E"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 112,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 112,
    r: 13
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104 145 Q120 160 136 145",
    fill: "none",
    stroke: "#0E2A2E",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "bolt",
    d: "M126 82 l-22 34 h16 l-8 28 l24 -36 h-16 z",
    fill: "#FFD84D",
    stroke: "#0E2A2E",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFD84D"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "spark",
    cx: 62,
    cy: 180,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "spark s2",
    cx: 178,
    cy: 176,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "spark s3",
    cx: 120,
    cy: 196,
    r: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03Charging);
export default __webpack_public_path__ + "static/media/03-charging.882f3876f9bf140b341ccbbdfb76aa2d.svg";
export { ForwardRef as ReactComponent };